<!-- components/AboutUs.vue -->
<template>
  <section class="aboutUs" ref="aboutUsSection" id="aboutUs">
    <div class="aboutUs-visual">
      <transition name="pop" appear>
        <img
          v-if="isVisible"
          src="@/assets/images/fondoNY2.jpg"
          alt="Our Company"
          class="logo-image"
        />
      </transition>
    </div>
    <div class="aboutUs-content">
      <transition name="slide-up" appear>
        <h1>
          <img
            v-if="isVisible"
            :src="logo"
            @mouseover="logo = logo_blue"
            @mouseout="logo = logo_white"
            alt=""
            style="padding: 0; height: 1.6rem"
          />
        </h1>
      </transition>
      <transition name="fade" appear>
        <h1 v-if="isVisible">
          {{ lMessages["paragraph1"] }}
        </h1>
      </transition>
      <transition name="fade" appear>
        <h1 v-if="isVisible">{{ lMessages["paragraph2"] }}</h1>
      </transition>
      <transition name="fade" appear>
        <h1 v-if="isVisible">
          {{ lMessages["paragraph3"] }}
        </h1>
      </transition>
      <transition name="fade" appear>
        <h1 v-if="isVisible">
          {{ lMessages["paragraph4"] }}
        </h1>
      </transition>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    lMessages: { required: true, default: () => [] }
  },
  data() {
    return {
      isVisible: false,
      logo_white: require("@/assets/images/QuanspireLogoWhite.svg"),
      logo_blue: require("@/assets/images/QuanspireLogoBlue.svg"),
      logo: require("@/assets/images/QuanspireLogoWhite.svg")
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const section = this.$refs.aboutUsSection;
      const rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.8) {
        this.isVisible = true;
      } else if (rect.top > window.innerHeight * 0.01) {
        this.isVisible = false;
      }
    }
  }
};
</script>

<style scoped>
.aboutUs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 5% 2rem 5%;
  background: var(--darkbackgroundFixed);
  color: var(--white);
  overflow: hidden;
}
h1 {
  font-size: 1.2rem;
  color: var(--white);
  margin-bottom: 1rem;
  line-height: 1.2;
}
.logo-image {
  width: 100%;
  height: auto;
}

.aboutUs-visual {
  position: relative;
  max-width: 40%;
}
.aboutUs-content {
  max-width: 60%;
  padding-left: 3rem;
}
.logo-image {
  width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.slide-up-enter-active {
  transition: all 1s ease 0.4s;
}
.slide-up-enter {
  opacity: 0;
  transform: translateY(50px);
}
.fade-enter-active {
  transition: all 0.8s ease 0.2s; /* Retraso para subtítulo */
}
.fade-enter {
  opacity: 0;
}

.pop-enter-active {
  transition: all 1s ease 0.4s;
}
.pop-enter {
  opacity: 0;
  transform: scale(0.8);
}
</style>
